import { useMutation } from '@apollo/client';
import { REGISTER_RFID } from 'graphql/mutations/registerRfid';
import { useState } from 'react';
import { Mutation, MutationRegisterRfidArgs } from 'types/generatedSchemaTypes';
import { useUiStore } from 'stores/uiStore';

const useRfidRegister = () => {
  const [registrationStatus, setRegistrationStatus] = useState<
    'idle' | 'loading' | 'success' | 'error'
  >('idle');
  const [errorMessage, setErrorMessage] = useState('');
  const [registerRfid] = useMutation<Mutation, MutationRegisterRfidArgs>(
    REGISTER_RFID,
    {
      onCompleted: async () => {
        setRegistrationStatus('success');
        setErrorMessage('');
        useUiStore.getState().setSheetModal('');
        useUiStore.getState().setSheetModal('rfidScan');
      },
      onError: (error) => {
        setRegistrationStatus('error');
        setErrorMessage('Failed to register RFID,');
      },
    }
  );
  return {
    registerRfid,
    registrationStatus,
    errorMessage,
    setRegistrationStatus,
    setErrorMessage,
  };
};
export default useRfidRegister;
